const actionPrefix = 'ContentEmbedUI';

/**
 * The list of all the postMessage event actions.
 */
export const EventActions = {
  READY: `${actionPrefix}:Ready`,
  SIZE_CHANGE: `${actionPrefix}:SizeChange`,
  SET_CONTENT: `${actionPrefix}:SetContent`,
  SET_CONTENT_DONE: `${actionPrefix}:SetContentDone`,
  DISCONNECT: `${actionPrefix}:Disconnect`
};

/**
 * List of valid host origins to connect to.
 */
export const OriginRegexAllowList = [/^https:\/\/((local|app)(-[^.]+)?|[\w-]+\.local\.app)\.hubspot(qa)?\.com/, /^https:\/\/preview.hs-sites(qa)?.com/, /^https:\/\/([0-9]+).hubspotpreview([^.]+)?.com/];
export const QueryParamKeys = {
  ID: 'id',
  INPAGE: 'inpage',
  ORIGIN: 'origin',
  INCLUDE_HEAD_ELEMENTS: 'includeHeadElements',
  SHOULD_REPLACE_ALL_HTML: 'shouldReplaceAllHTML'
};

// Attribute to flag dynamically added DOM nodes
export const DYNAMIC_CONTENT_ATTR = 'data-dynamic-content';